'use strict';
import App from 'system/app'
import Theme from 'theme/layout'

// routed modules
import '@expressive-analytics/vue-login'

// styles
//import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'
//import Skin from '@expressive-analytics/skin-ea-basic'
import "css"

// make sure that all routed modules are loaded before calling init()
// i.e. if your route contains "use:", load it above
App.init()

import Vue from 'vue'
Vue.config.productionTip = false // stop being annoying

import moment from 'moment'
Vue.filter('date',(val,fmt)=>{
  let d = moment(val)
  if(d.isValid())
    return moment(val).format(fmt)
  return ''
})

Vue.filter('fromNow',(val)=>{
  return moment(val).fromNow()
})

Vue.filter('number',(val,num)=>{
  if(!val)
    return 0.00;
  if(typeof(num)=="undefined")
    num = 2
  if(val=="-")
    return "";
  if(parseFloat(val)===Number.NEGATIVE_INFINITY)
    return "N/A"
  return parseFloat(val).toLocaleString('en-us',{maximumFractionDigits:num,minimumFractionDigits:num})
})

Vue.filter('bytes',(bytes, precision)=>{
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
  if (typeof precision === 'undefined') precision = 1;
  var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
    number = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
})

// common, app-wide UI elements
import VueSelect from 'vue-select'
Vue.component('v-select',VueSelect)
import "vue-select/src/scss/vue-select.scss";

import Datepicker from 'vue-bootstrap-datetimepicker'
Vue.use(Datepicker)
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
